import { render, staticRenderFns } from "./SignSupervisor.vue?vue&type=template&id=a1081068&scoped=true&"
import script from "./SignSupervisor.vue?vue&type=script&lang=js&"
export * from "./SignSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./SignSupervisor.vue?vue&type=style&index=0&id=a1081068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1081068",
  null
  
)

export default component.exports